import DelectoryResource from '../DelectoryResource';

class WineSkus extends DelectoryResource {
  constructor(opts) {
    super(opts);

    this.wineSku = DelectoryResource.createEndpoint({
      authRequired: false,
      path: '/web/wine_skus/wine_sku'
    });

    this.list = DelectoryResource.createEndpoint({
      authRequired: false,
      path: '/web/wine_skus/search'
    });
  }
}

export default WineSkus;



// WEBPACK FOOTER //
// banquet/lib/DelectoryApi/lib/resources/WineSkus.js